(function (Drupal, $) {
  Drupal.behaviors.hero = {
    attach: function attach(context) {
      if ($(context).find(".field__field-hero.swiper-container").length) {
        var heroSwiper = new Swiper(".field__field-hero", {
          autoHeight: false,
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          slidesPerView: 1,
          spaceBetween: 30,
          speed: 500,
          pagination: {
            el: '.swiper-hero-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-hero-next',
            prevEl: '.swiper-hero-prev',
          },
          on: {
            paginationUpdate: function (_swiper, paginationEl) {
              handleAriaForPagination(paginationEl);
            },
            init: function(_swiper) {
              handleAriaForSlides(_swiper);
            },
            slideChange: function(_swiper) {
              handleAriaForSlides(_swiper);
            }
          },
        });

        // Set all hero sections to the same height to prevent jumping
        var heroSameHeight = 0;
        $(".paragraph--type--hero .content-wrapper").each(function(){
          if ($(this).height() > heroSameHeight) { heroSameHeight = $(this).height(); }
        });
        $(".paragraph--type--hero .content-wrapper").height(heroSameHeight);
      }

      // Make only visible slides not aria-hidden
      // Make all hidden slides' interactive content a negative tab index
      function handleAriaForSlides(_swiper) {
        $(_swiper.$el).find('.swiper-slide').attr('aria-hidden', true);
        $(_swiper.$el).find('.swiper-slide').find('a').attr('tabindex', -1);
        $(_swiper.$el).find('.swiper-slide-visible').attr('aria-hidden', false);
        $(_swiper.$el).find('.swiper-slide-visible').find('a').attr('tabindex', 0);
      }

      function handleAriaForPagination(paginationEl) {
        $(paginationEl).find('.swiper-pagination-bullet').removeAttr('aria-current');
        $(paginationEl).find('.swiper-pagination-bullet-active').attr('aria-current', true);
      }
    }
  }
})(Drupal, jQuery);
